import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left pt-4 px-4 md:px-6 xl:pt-10 xl:px-[72px]" }
const _hoisted_2 = { class: "text-brown sf-pro font-medium text-2xl leading-100p md:text-[32px] xl:text-[40px] mb-2 xl:mb-4" }
const _hoisted_3 = { class: "text-muted sf-pro font-normal text-sm leading-[21px] md:text-base md:leading-[24px] xl:leading-[28px] mb-2 xl:mb-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "sf-pro font-normal text-sm leading-[21px] md:text-base md:leading-[24px] xl:text-xl xl:leading-[28px] text-brown list-disc list-outside mb-2 md:mb-8 xl:mb-10 pl-2 ml-5 space-y-2"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import { computed } from "vue";
import { BlogDetail } from "@/types/blogs";
import { useLangStore } from "@/stores/langStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogContent',
  props: {
    blog: {}
  },
  setup(__props: any) {

const props = __props;

const langStore = useLangStore();
const langBlocks = computed(
  () =>
    props.blog.blocks[langStore.current] ||
    props.blog.blocks[langStore.fallbackLang]
);
const textBlockStyles = {
  large:
    "sf-pro font-semibold text-xl leading-100p md:text-2xl md:leading-[32px] mb-2 md:mb-4 xl:mb-6",
  medium:
    "sf-pro font-semibold text-base leading-[24px] md:leading-[21px] xl:text-xl xl:leading-[28px] mb-2 xl:mb-4",
  body: "sf-pro font-normal text-sm leading-[21px] md:text-base md:leading-[24px] xl:text-xl xl:leading-[28px] mb-4 md:mb-6 xl:mb-8",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(props.blog.titles[_unref(langStore).current] ||
        props.blog.titles[_unref(langStore).fallbackLang]), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(props.blog.created_at), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langBlocks.value, (languageBlock) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: languageBlock.id
      }, [
        (languageBlock.type == 'image')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: languageBlock.image_url,
              alt: "blog image",
              class: "rounded-[20px] mb-10"
            }, null, 8, _hoisted_4))
          : (languageBlock.type == 'list')
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageBlock.list_items, (listItem) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: listItem.order,
                    innerHTML: listItem.value
                  }, null, 8, _hoisted_6))
                }), 128))
              ]))
            : (languageBlock.type == 'text')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["text-brown [&>*]:text-inherit [&>*]:font-inherit", textBlockStyles[languageBlock.style]])
                }, [
                  _createElementVNode("div", {
                    innerHTML: languageBlock.content.replace(/\r\n/g, '<br>')
                  }, null, 8, _hoisted_7)
                ], 2))
              : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})